import { mergeConfig } from "../configApi.mjs";
import { post } from "../configHttp.mjs";
const UserApi = {
  config: {},
  urls: {
    authorize: "/oauth2/authorize",
    logout: "/api/oauth2/logout",
    userInfo: "/v1/user/getLoginUserInfo"
  },
  getUserCenterUrl(redirectUrl) {
    const { loginBaseUrl, clientId, callbackUrl } = mergeConfig(UserApi.config);
    const currentUrl = encodeURIComponent(window.location.href);
    return `${loginBaseUrl}${UserApi.urls.authorize}?response_type=code&client_id=${clientId}&redirect_uri=${callbackUrl}&scope=openid&state=${redirectUrl || currentUrl}`;
  },
  logout(token, redirectUri) {
    const { loginBaseUrl } = mergeConfig(UserApi.config);
    return `${loginBaseUrl}${UserApi.urls.logout}?idToken=${token}&redirectUri=${redirectUri}`;
  },
  logoutByRequest(token, redirectUri) {
    const { baseUrl } = mergeConfig(UserApi.config);
    const logoutUrl = `${baseUrl}/logout?post_logout_redirect_uri=${redirectUri}&token=${token}`;
    return logoutUrl;
  },
  async getUserInfo(token) {
    const { baseUrl } = mergeConfig(UserApi.config);
    const authorization = token;
    if (!authorization) {
      console.warn("\u672A\u63D0\u4F9B token \u4FE1\u606F\uFF0C\u8BF7\u68C0\u67E5\u7528\u6237\u767B\u5F55\u72B6\u6001");
      return Promise.reject(false);
    } else {
      const res = await post(`${baseUrl}${UserApi.urls.userInfo}`, {}, {
        headers: {
          authorization
        }
      });
      res.code = "0";
      return Promise.resolve(res);
    }
  }
};
export { UserApi };
